export enum Platform {
  PRO_CONNECT = 'pro-connect',
  H2H = 'h2h',
}
